define(['jquery', 'datatables.net',
  'datatables.net',
  'datatables.net-bs4',
  'datatables.net-buttons',
  'datatables.net-buttons-bs4',
  'datatables.net-buttons-colvis',
  'datatables.net-buttons-print',
  'datatables.net-buttons-html',
  'datatables.net-buttons-flash',
  'datatables.net-responsive',
  'datatables.net-responsive-bs4'], function($) {
    return {
        init: function() {
          $('#partners_table').DataTable();
        }
    };
});
